<script setup>
import {
  computed,
  defineAsyncComponent,
  onMounted,
  onBeforeUnmount,
} from "vue";
import Preloader from "@/components/Preloader.vue";
const ErrorModal = defineAsyncComponent(() =>
  import("@/components/Modals/ErrorModal.vue")
);
import successFeedback from "@/components/Modals/GlobalSuccessFeedback.vue";
import { useStore } from "vuex";
import { VueQueryDevTools } from "vue-query/devtools";
import { useQueryProvider } from "vue-query";
import { Toaster } from "@starline-security/component-library";
import { queryClient } from "@/queryClient";

useQueryProvider(queryClient);

const store = useStore();
const loading = computed(() => store.getters["preloader/preloader"]);
const routeLoading = computed(() => store.getters["preloader/routeLoading"]);

// function handleScroll() {
//   if (window.scrollY > 5) {
//     document.body.classList.add("scrolled");
//   } else {
//     document.body.classList.remove("scrolled");
//   }
// }

// onMounted(() => {
//   window.addEventListener("scroll", handleScroll);
// });

// onBeforeUnmount(() => {
//   window.removeEventListener("scroll", handleScroll);
// });
</script>

<template>
  <router-view></router-view>
  <transition name="slide">
    <Preloader
      v-if="loading || routeLoading"
      :class="routeLoading ? 'tw:opacity-40' : ''"
    />
  </transition>
  <Toaster />
  <ErrorModal />
  <successFeedback />
  <VueQueryDevTools />
</template>

<style lang="scss">
@layer base {
  // @import "assets/scss/main";

  #app-container {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .topLine {
    display: block;
    height: 20px;
    width: 100%;
  }

  .v3dp__datepicker {
    .v3dp__input_wrapper {
      input {
        padding: 0.5rem 0.3rem;
        border: none;
        border-bottom: 2px solid #0e3753;
        font-size: 1rem;
        max-width: 120px;
        text-align: right;
      }
    }
  }

  *.tw-overflow-y-auto[id^="headlessui-dialog-"] {
    z-index: 100 !important;
  }
}
</style>
